<template>
    <section class="content">
      <div>
        <div id="overlay" v-if="loading">
          <div class="spinner"></div>
          <br/>
          <h4>Loading...</h4>
        </div>
        <div class="box box-info">
          <form>
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button @click.prevent="searchReport"
                        class="p-button-raised" label="Search" icon="pi pi-search"/>
              </div>
            </div>
          </form>
  
          <DataTable :value="analysisSalesMonthlyCustomerFiscalYearWiseLists"
                     ref="po"
                     exportFilename="salesAnalysisMonthlyCustomerWise"
                     :rowsPerPageOptions="[100,500,1000]" 
                     :paginator="true" 
                     :rows="100" 
                     :filters="filters"
                     class="p-datatable-responsive p-datatable-gridlines"
                     data-key="id">
            <template #header>
              <div style="text-align: left">
                <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
              </div>
            </template>
  
            <Column header="Account" field="accountName" :sortable="true" filterMatchMode="contains">
              <template #filter><InputText v-model="filters['accountName']" class="p-column-filter"/></template>
            </Column>
  
            <!-- Previous FY Months (previous/current) -->
            <Column header="Shrawan previous" field="m4Sales"/>
            <Column header="Bhadra previous" field="m5Sales"/>
            <Column header="Ashwin previous" field="m6Sales"/>
            <Column header="Kartik previous" field="m7Sales"/>
            <Column header="Mangsir previous" field="m8Sales"/>
            <Column header="Poush previous" field="m9Sales"/>
            <Column header="Magh previous" field="m10Sales"/>
            <Column header="Falgun previous" field="m11Sales"/>
            <Column header="Chaitra previous" field="m12Sales"/>
  
            <!-- Current FY Months (current/2083) -->
            <Column header="Baisakh previous" field="m1Sales"/>
            <Column header="Jestha previous" field="m2Sales"/>
            <Column header="Ashadh previous" field="m3Sales"/>
            <Column header="Shrawan current" field="m4Sales2"/>
            <Column header="Bhadra current" field="m5Sales2"/>
            <Column header="Ashwin current" field="m6Sales2"/>
            <Column header="Kartik current" field="m7Sales2"/>
            <Column header="Mangsir current" field="m8Sales2"/>
            <Column header="Poush current" field="m9Sales2"/>
            <Column header="Magh current" field="m10Sales2"/>
            <Column header="Falgun current" field="m11Sales2"/>
            <Column header="Chaitra current" field="m12Sales2"/>
            <Column header="Baisakh current" field="m1Sales2"/>
            <Column header="Jestha current" field="m2Sales2"/>
            <Column header="Ashadh current" field="m3Sales2"/>
  
            <!-- <Column header="Total" field="total"/> -->
            <Column header="Next Order (AD)" field="nextExpectedOrderAD"/>
            <Column header="Next Order (BS)" field="nextExpectedOrderBS"/>
            <Column header="Follow-up Status" field="followUpStatus"/>
  
            <template #empty>No record found</template>
          </DataTable>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'
  import InputText from 'primevue/inputtext'
  import Button from 'primevue/button'
  
  export default {
    name: 'analysisSalesMonthlyCustomerFiscalYearWiseLists',
    data() {
      return {
        analysisSalesMonthlyCustomerFiscalYearWiseLists: [],
        loading: false,
        filters: {}
      }
    },
    mounted() {
      this.loadSalesReport()
    },
    methods: {
      async loadSalesReport() {
        try {
          this.loading = true
        //   const response = await this.$axios.get(`/inventoryAnalysis/reportpreviousAndCurrentSalesByfiscalyear/`, {
        //     params: { organisationId: this.organisationId , organisationId: this.organisationId}
        //   })
          let response = await this.$store.dispatch('loadSalesAnalysisMonthlyCustomerWiseFiscalYearReport')
          console.log(response)
          this.analysisSalesMonthlyCustomerFiscalYearWiseLists = response.data.map(item => ({
            accountName: item.customerName,
            // Previous FY months
            m4Sales: item.shravanprevious || 0,
            m5Sales: item.bhadraprevious || 0,
            m6Sales: item.aswinprevious || 0,
            m7Sales: item.kartikprevious || 0,
            m8Sales: item.mansirprevious || 0,
            m9Sales: item.poushprevious || 0,
            m10Sales: item.maghprevious || 0,
            m11Sales: item.falgunprevious || 0,
            m12Sales: item.chaitraprevious || 0,
            m1Sales: item.baishakhprevious || 0,
            m2Sales: item.jyeshthaprevious || 0,
            m3Sales: item.aashadprevious || 0,
            // current
            m4Sales2: item.shravancurrent || 0,
            m5Sales2: item.bhadracurrent || 0,
            m6Sales2: item.aswincurrent || 0,
            m7Sales2: item.kartikcurrent || 0,
            m8Sales2: item.mangsircurrent || 0,
            m9Sales2: item.poushcurrent || 0,
            m10Sales2: item.maghcurrent || 0,
            m11Sales2: item.falguncurrent || 0,
            m12Sales2: item.chaitracurrent || 0,
            m1Sales2: item.baishakhcurrent || 0,
            m2Sales2: item.jyeshthacurrent || 0,
            m3Sales2: item.aashadcurrent || 0,
            // Total
            // total: Object.values({
            //   m4Sales: item.shravanprevious || 0,
            //   m5Sales: item.bhadraprevious || 0,
            //   m6Sales: item.aswinprevious || 0,
            //   m7Sales: item.kartikprevious || 0,
            //   m8Sales: item.mansirprevious || 0,
            //   m9Sales: item.poushprevious || 0,
            //   m10Sales: item.maghprevious || 0,
            //   m11Sales: item.falgunprevious || 0,
            //   m12Sales: item.chaitraprevious || 0,
            //   m1Sales: item.baishakhcurrent || 0,
            //   m2Sales: item.jyeshthacurrent || 0,
            //   m3Sales: item.aashadcurrent || 0,
            //   m4Sales2: item.shravancurrent || 0,
            //   m5Sales2: item.bhadracurrent || 0,
            //   m6Sales2: item.aswincurrent || 0,
            //   m7Sales2: item.kartikcurrent || 0,
            //   m8Sales2: item.mangsircurrent || 0,
            //   m9Sales2: item.poushcurrent || 0,
            //   m10Sales2: item.maghcurrent || 0,
            //   m11Sales2: item.falguncurrent || 0,
            //   m12Sales2: item.chaitracurrent || 0
            // }).reduce((a,b) => a+b,0),
            nextExpectedOrderAD: item.nextExpectedOrderAD,
            nextExpectedOrderBS: item.nextExpectedOrderBS,
            followUpStatus: item.followUpStatus
          }))
        } catch (error) {
          console.error('Error loading sales report:', error)
        } finally {
          this.loading = false
        }
      },
      searchReport() {
        this.loadSalesReport()
      },
      exportCSV() {
        this.$refs.po.exportCSV()
      }
    },
    components: { DataTable, Column, InputText, Button }
  }
  </script>
  
  <style scoped>
  .spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }
  @keyframes spin { 100% { transform: rotate(360deg); } }
  #overlay {
    position: fixed;
    top:0; left:0; width:100%; height:100%;
    background: rgba(255,255,255,0.7);
    display:flex; justify-content:center; align-items:center; flex-direction:column;
    z-index:9999;
  }
  </style>



// WEBPACK FOOTER //
// salesAnalysisFiscalYearWiseMonthly.vue?2dbc14f0